// 此文件由脚本自动生成，请勿直接修改。
// This file was generated automatically by a script. Please do not modify it directly.

import { ProgressTokens } from './type';

const progressTokens: ProgressTokens = {
  progressFontSize: '14/regular',
  progressFontColor: 'Neutral-text-4',
  progressBackground: 'Neutral-fill-3',
  progressInfoFrontBackgroundColor: 'Brand-6',
  progressWarningFrontBackgroundColor: 'Warning-6',
  progressSuccessFrontBackgroundColor: 'Success-6',
  progressDangerFrontBackgroundColor: 'Danger-6',
  progressLineHeight: 'Size-3',
  progressLineGap: 'Margin-8',
  progressLineInnerHeight: 'Size-10',
  progressLineInnerGap: 'Margin-8',
  progressLineInnerPaddingX: 'Padding-8',
  progressLineInnerFontColor: 'Neutral-text-1',
  progressLineInnerFontSize: '12/regular',
  progressLineInnerRightFontColor: 'Neutral-text-5',
  progressLineIconSize: 'Size-7',
  progressLineBackgroundColor: 'Neutral-fill-9',
  progressLineColor: 'Neutral-text-1',
};

export default progressTokens;
